import { render, staticRenderFns } from "./messageForm.vue?vue&type=template&id=850761ee"
import script from "./messageForm.vue?vue&type=script&lang=js"
export * from "./messageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports